import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  isLoggedIn$: Observable<boolean>;
  
  constructor(
    private authService: AuthService,
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService) {  }

  ngOnInit() {
    this.spinnerService.show();
    // Log current path
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd)
      )
      .subscribe( (navEnd:NavigationEnd) => {
        if (navEnd.urlAfterRedirects === '/login') this.authService.clearSession();
        console.log("Current Route:", navEnd.urlAfterRedirects);
      });

    this.isLoggedIn$ = this.authService.isLoggedIn;
    this.spinnerService.hide();
  }

  OnLogout(){
    this.authService.logout();
  }
}
